import Alert from '@mui/material/Alert';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { reasonMessage } from '../../i18n';
import type { ApiError } from '../../lib/api/api-client';

/**
 * The catalogue text of a failure (S8 R20, I12): never a problem `title` or a body. A network
 * failure carries `INTERNAL_ERROR`. MUI's Alert is `role="alert"`, so it is announced.
 */
export function ReasonAlert({ error }: { readonly error: ApiError }): ReactElement {
  const { t } = useTranslation();
  const message = reasonMessage(error.reasonCode, error.params);
  return <Alert severity="error">{t(message.key, message.values)}</Alert>;
}
